import React from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Text,
  VStack,
  Divider,
  useBreakpointValue,
} from "@chakra-ui/react";

// ✅ Replace this path with your actual asset path
import confirmationImage from "../../assets/authentication/bg.png";

const Registrationcomplete = () => {
  const boxWidth = useBreakpointValue({ base: "90%", sm: "xs", md: "md" });

  return (
    <Flex minH="100vh" bg="gray.50" justify="center" align="start" pt={16} px={2}>
      <Box
        bg="white"
        w={boxWidth}
        rounded="md"
        p={{ base: 6, md: 8 }}
        boxShadow="md"
        textAlign="center"
      >
        <VStack spacing={4}>
          <Image
            src={confirmationImage}
            alt="Confirmation Illustration"
            boxSize={{ base: "80px", md: "100px" }}
            mx="auto"
          />

          <Heading fontSize={{ base: "lg", md: "2xl" }} fontWeight="bold">
            Almost There!
          </Heading>

          <Text fontSize="sm" color="gray.600">
            Check your email inbox and confirm your account
          </Text>

          <Divider />

          <Text fontSize="xs" color="gray.500">
            Didn’t receive any mail?
          </Text>

          <Button
            variant="outline"
            colorScheme="blue"
            size="sm"
            fontSize="xs"
            w="full"
          >
            Resend Confirmation
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
};

export default Registrationcomplete;
